// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"CloseButton_closeBtn_2t82P","spacer":"CloseButton_spacer_1lJp6","hasBackground":"CloseButton_hasBackground_1Jc_S"};